module.exports = __webpack_public_path__ + "5294aeb4e9d3e1856c1644a49497eaed.svg";